import React from 'react'
import LabelBox, { LabelBoxEnumStr } from 'components/base-ui/LabelBox'
import Fonts from 'components/base-ui/Fonts'
import { Wrapper } from './styled'

export interface AlertLabelBoxProps {
  show: boolean
  alertText: string
  type: LabelBoxEnumStr
}

const AlertLabelBox = ({ show, alertText, type = 'success' }: AlertLabelBoxProps) => {
  return (
    <Wrapper show={show}>
      <LabelBox type={type} text={<Fonts.SmallTitleBold>{alertText}</Fonts.SmallTitleBold>} />
    </Wrapper>
  )
}

export default AlertLabelBox
